import { equals } from "@/helpers/ObjectsHelper";
import { Serializable, SerializationHelper } from "@/helpers/SerializationHelper";

export class FishingOrigin implements Serializable {
  productionType: string;
  productionMethod: string;
  scientificName: string;
  fishingArea: string;
  fishingSubArea: string;
  fishingTechnique: string;
  breedingCountry: string;

  constructor() {
    this.productionType = null;
    this.productionMethod = null;
    this.scientificName = null;
    this.fishingArea = null;
    this.fishingSubArea = null;
    this.fishingTechnique = null;
    this.breedingCountry = null;
  }

  fromJSON(obj: any) {
    SerializationHelper.copyNonExcludedProperties(this, obj, []);
  }

  public equals(that: FishingOrigin): boolean {
    if (that == null) {
      return false;
    }

    return equals(this, that, (p: FishingOrigin) => p.productionType)
        && equals(this, that, (p: FishingOrigin) => p.productionMethod)
        && equals(this, that, (p: FishingOrigin) => p.scientificName)
        && equals(this, that, (p: FishingOrigin) => p.fishingArea)
        && equals(this, that, (p: FishingOrigin) => p.fishingSubArea)
        && equals(this, that, (p: FishingOrigin) => p.fishingTechnique)
        && equals(this, that, (p: FishingOrigin) => p.breedingCountry);
      }
}
